// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__IBMPlexSansMedium_414676', '__IBMPlexSansMedium_Fallback_414676'","fontWeight":500},"className":"__className_414676","variable":"__variable_414676"};